import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var PlatformStorageClass;
function PlatformStorage() {
  if (PlatformStorageClass === VOID) {
    class $ {
      gi(key) {
        return window.localStorage.getItem(key);
      }
      rd8(key, value) {
        window.localStorage.setItem(key, value);
      }
    }
    initMetadataForObject($, 'PlatformStorage');
    PlatformStorageClass = $;
  }
  return PlatformStorageClass;
}
var PlatformStorage_instance;
function PlatformStorage_getInstance() {
  return PlatformStorage_instance;
}
//region block: init
PlatformStorage_instance = new (PlatformStorage())();
//endregion
//region block: exports
export {
  PlatformStorage_instance as PlatformStorage_instance2f13b75vguf60,
};
//endregion

//# sourceMappingURL=PlatformStorage.mjs.map
